"use client";
import React, { useRef } from "react";
import Image from "next/image";
import { motion, useInView } from "framer-motion";
import ArrowLeft from "@/components/icons/arrow-left";
import Link from "next/link";

const NewsCard = ({
  item,
  isLast = false,
  index,
  cardWidth = "w-full",
  imageHeights = {
    base: "h-[230px]",
    lg: "lg:h-[200px]",
    xl: "xl:h-[250px]",
    xxl: "2xl:h-[340px]",
    hoverBase: "group-hover:lg:h-[218px]",
    hoverXl: "group-hover:xl:h-[267px]",
    hoverXxl: "group-hover:2xl:h-[358px]",
  },
}) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-50px" });

  const cardVariants = {
    hidden: { opacity: 0, x: 10 },
    visible: (i) => ({
      opacity: 1,
      x: 0,
      transition: {
        delay: i * 0.2,
        type: "spring",
        stiffness: 500,
      },
    }),
  };

  return (
    <motion.div
      ref={ref}
      className={`bg-white bg-opacity-15 lg:w-[25%] xl:w-[20%] text-white group pl-1 border-r border-green-1 flex flex-col justify-between`}
      variants={cardVariants}
      initial="hidden"
      animate={isInView ? "visible" : "hidden"}
      custom={index}
    >
      <div>
        <div className="group-hover:p-0 group-hover:duration-700">
          <Image
            src={item.src}
            alt={item.alt || "News image"}
            className={`rounded-lg rounded-b-none w-full h-56 object-cover`}
            width={1000}
            height={500}
            sizes="(max-width: 768px) 100vw, (max-width: 1280px) 50vw, 25vw"
          />
        </div>
        <div className="bg-white text-[#011C4E] group-hover:lg:bg-white group-hover:lg:text-[#011C4E] p-2 rounded-b-lg group-hover:rounded-b-lg group-hover:duration-700">
          <p className="text-sm text-medium text-green-1">{item.date}</p>
          <p className="lg:underline group-hover:no-underline mb-4 font-medium">
            {item.heading}
          </p>
        </div>
      </div>
      <div>
        <Link
          href={item.url}
          target="_blank"
          className="relative inline-block cursor-pointer outline-none border-0 align-middle bg-transparent p-0 w-48 group"
          aria-label="Read more about this news"
        >
          <span className="relative block m-0 w-full lg:w-11 h-11 bg-green-1 rounded-full transition-all duration-[450ms] ease-[cubic-bezier(0.65,0,0.076,1)] group-hover:w-full">
            <span className="absolute top-1/2 left-3 -translate-y-1/2 transition-all duration-[450ms] ease-[cubic-bezier(0.65,0,0.076,1)] group-hover:translate-x-4">
              <ArrowLeft
                className="h-5 w-5 rotate-180 text-white group-hover:lg:text-white"
                stroke="2.5"
              />
            </span>
          </span>
          <span className="absolute inset-0 pl-10 pr-0 py-2.5 text-sm text-white font-medium leading-snug text-center transition-all duration-[450ms] ease-[cubic-bezier(0.65,0,0.076,1)] group-hover:text-white">
            Read More...
          </span>
        </Link>
      </div>
    </motion.div>
  );
};

export default NewsCard;
